
// @ts-ignore
export default function Pruebas(props: any) {

  return (
    <>

    </>
  )

}

